export enum DTOGroup {
  MAIN = 'main',
  CREATE = 'create',
  UPDATE = 'update'
}
